/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConsentPayloadFromJSON, ConsentPayloadToJSON } from './ConsentPayload';
/**
 * Check if a given object implements the TrackVisitRequest interface.
 */
export function instanceOfTrackVisitRequest(value) {
    if (!('consent' in value) || value['consent'] === undefined)
        return false;
    return true;
}
export function TrackVisitRequestFromJSON(json) {
    return TrackVisitRequestFromJSONTyped(json, false);
}
export function TrackVisitRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'consent': ConsentPayloadFromJSON(json['consent']),
        'fbc': json['fbc'] == null ? undefined : json['fbc'],
        'fbclid': json['fbclid'] == null ? undefined : json['fbclid'],
        'fbp': json['fbp'] == null ? undefined : json['fbp'],
        'gclid': json['gclid'] == null ? undefined : json['gclid'],
        'landingUrl': json['landing_url'] == null ? undefined : json['landing_url'],
        'referrer': json['referrer'] == null ? undefined : json['referrer'],
        'ttclid': json['ttclid'] == null ? undefined : json['ttclid'],
        'utmCampaign': json['utm_campaign'] == null ? undefined : json['utm_campaign'],
        'utmContent': json['utm_content'] == null ? undefined : json['utm_content'],
        'utmMedium': json['utm_medium'] == null ? undefined : json['utm_medium'],
        'utmSource': json['utm_source'] == null ? undefined : json['utm_source'],
        'utmTerm': json['utm_term'] == null ? undefined : json['utm_term'],
    };
}
export function TrackVisitRequestToJSON(json) {
    return TrackVisitRequestToJSONTyped(json, false);
}
export function TrackVisitRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'consent': ConsentPayloadToJSON(value['consent']),
        'fbc': value['fbc'],
        'fbclid': value['fbclid'],
        'fbp': value['fbp'],
        'gclid': value['gclid'],
        'landing_url': value['landingUrl'],
        'referrer': value['referrer'],
        'ttclid': value['ttclid'],
        'utm_campaign': value['utmCampaign'],
        'utm_content': value['utmContent'],
        'utm_medium': value['utmMedium'],
        'utm_source': value['utmSource'],
        'utm_term': value['utmTerm'],
    };
}
